module.exports = __webpack_public_path__ + "static/media/Search.ec21efbb.svg";